import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { getMaterialityChipColor, getMaterialityChipText } from '~/functions/csrd';
import { EnumIroType, EnumIroStatus } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'iro',
  props: {
    iro: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true,
      validator: function validator(value) {
        return Object.values(EnumIroType).includes(value);
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var iroEditPath = computed(function () {
      return props.iro && props.iro.id ? "/csrd/iro/".concat(props.iro.id, "/edit") : '#';
    });
    var iroName = computed(function () {
      return props.iro && props.iro.name ? props.iro.name : '';
    });
    return {
      __sfc: true,
      props: props,
      iroEditPath: iroEditPath,
      iroName: iroName,
      getMaterialityChipColor: getMaterialityChipColor,
      getMaterialityChipText: getMaterialityChipText,
      EnumIroStatus: EnumIroStatus
    };
  }
});